export default "__VITE_ASSET__33c4c96f__"